import { render, staticRenderFns } from "./paypal-fees.vue?vue&type=template&id=721c37f3&scoped=true&"
import script from "./paypal-fees.vue?vue&type=script&lang=js&"
export * from "./paypal-fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c37f3",
  null
  
)

export default component.exports